import PropTypes from 'prop-types';


const agreement = PropTypes.shape({
  code: PropTypes.string,
  extendedText: PropTypes.string,
  id: PropTypes.number,
  links: PropTypes.array,
  text: PropTypes.string
});

export default agreement;
